import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import HttpApi from "i18next-http-backend";
import LanguageDetector from 'i18next-browser-languagedetector';

import de from '@/assets/locales/de';
import en from '@/assets/locales/en';

i18n
  .use(initReactI18next)
  // .use(HttpApi)
  .use(LanguageDetector)
  .init({
    // ns: ["default"],
    // backend: {
    //   loadPath: "@/assets/locales/{{lng}}/{{ns}}.ts",
    // },

    resources: {
      en,
      de
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    defaultNS: 'default',
    fallbackNS: 'default',
    detection: {
      order: [
        'querystring',
        'localStorage',
        'sessionStorage',
        'navigator',
        'cookie',
        'htmlTag',
        'path'
      ],
      caches: ['cookie', 'localStorage', 'sessionStorage'],
      convertDetectedLanguage: (lng) => lng.replace(/-.+$/, '') // de-DE -> de
    }
  });

export default i18n;
